import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BatchJob, UnmatchedContainer } from '../../shared/models/batch.model';

interface DialogData {
  batchJob: BatchJob;
}

@Component({
  host: { 'test-id': 'batch-job-dialog' },
  selector: 'batch-job-dialog',
  styleUrls: ['./batch-job-dialog.component.scss'],
  template: `
    <h1 mat-dialog-title>Review Jobs</h1>
    <div mat-dialog-content>
      <div class="container-bucket" fwTooltipPosition="left" [fwTooltip]="getLabelTooltip(batchJob.matched)">
        <span>{{ batchJob.matched.length }}</span>
        <span>Jobs will be queued</span>
      </div>
      @if (batchJob.not_matched.length > 0) {
        <div
          class="container-bucket error-case"
          fwTooltipPosition="left"
          [fwTooltip]="getLabelTooltip(batchJob.not_matched)"
        >
          <span>{{ batchJob.not_matched.length }}</span>
          <span>Containers did not match gear inputs</span>
        </div>
      }
      @if (batchJob.ambiguous.length > 0) {
        <div
          class="container-bucket error-case"
          fwTooltipPosition="left"
          [fwTooltip]="getLabelTooltip(batchJob.ambiguous)"
        >
          <span>{{ batchJob.ambiguous.length }}</span>
          <span>Containers had ambiguous file inputs</span>
        </div>
      }
      @if (batchJob.improper_permissions.length > 0) {
        <div
          class="container-bucket error-case"
          fwTooltipPosition="left"
          [fwTooltip]="getLabelTooltip(batchJob.improper_permissions)"
        >
          <span>{{ batchJob.improper_permissions.length }}</span>
          <span>Containers with improper permissions</span>
        </div>
      }
      <p>
        Jobs are unable to be queued when the file choice is ambiguous or insufficient, or you lack adequate permission
        to access the data.
      </p>
    </div>
    <div align="end" mat-dialog-actions>
      <button mat-stroked-button test-id="cancel-button" [mat-dialog-close]="false">
        {{ canRun ? 'Cancel' : 'Close' }}
      </button>
      @if (canRun) {
        <button color="primary" mat-flat-button test-id="run-button" [mat-dialog-close]="true">Run Jobs</button>
      }
    </div>
  `,
  standalone: false,
})
export class BatchJobDialog {
  private data = inject<DialogData>(MAT_DIALOG_DATA);

  batchJob: BatchJob = this.data.batchJob;

  constructor() {
    const ref = inject<MatDialogRef<BatchJobDialog, boolean>>(MatDialogRef);

    ref.disableClose = true;
  }

  get canRun(): boolean {
    return this.batchJob.matched.length > 0;
  }

  getLabelTooltip(bucket: UnmatchedContainer[]): string {
    return bucket.map((container) => container.label ?? container._id).join('\n');
  }
}
